import { PropsWithChildren } from 'react';
import ErrorBoundary from 'src/components/ErrorBoundary';

const DashboardLayout: React.FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <ErrorBoundary>
      <div className="w-full min-w-0 max-w-full overflow-x-clip">
        {children}
      </div>
    </ErrorBoundary>
  );
};

export default DashboardLayout;
